import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import analytics from '../utils/analytics';

function PageTracker() {
  const location = useLocation();
  const { currentUser: user } = useAuth();
  const lastTrackedPath = useRef(null);
  const lastTrackedTime = useRef(0);

  useEffect(() => {
    // Prevent duplicate tracking within 1 second (handles React Strict Mode double renders)
    const now = Date.now();
    const currentPath = location.pathname;
    
    if (currentPath === lastTrackedPath.current && (now - lastTrackedTime.current) < 1000) {
      return; // Skip duplicate tracking
    }
    
    lastTrackedPath.current = currentPath;
    lastTrackedTime.current = now;

    // Track social media referrals from UTM parameters
    const urlParams = new URLSearchParams(location.search);
    const utmMedium = urlParams.get('utm_medium');
    const utmSource = urlParams.get('utm_source');
    
    if (utmMedium === 'social' && utmSource) {
      analytics.trackSocialReferral(utmSource);
    }

    // Track page views
    const pageName = getPageName(location.pathname);
    analytics.page(pageName, {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash
    });

    // Track specific page events
    if (location.pathname === '/daily-flush') {
      analytics.trackDailyFlushVisit();
    }
    
    // Track map loads (home page) - ONLY for authenticated users
    if ((location.pathname === '/' || location.pathname === '') && user) {
      analytics.trackMapLoad();
    }
  }, [location, user]);

  // Helper function to get human-readable page names
  const getPageName = (pathname) => {
    if (pathname === '/' || pathname === '') return 'home';
    if (pathname === '/app/admin') return 'admin_dashboard';
    if (pathname === '/porcelain-throne') return 'porcelain_throne';
    if (pathname === '/toilet-tower') return 'toilet_tower';
    if (pathname === '/royal-reviews') return 'royal_reviews';
    if (pathname === '/daily-flush') return 'daily_flush';
    if (pathname.startsWith('/auth')) return 'auth';
    if (pathname.startsWith('/qrcode')) return 'qr_landing';
    return pathname.replace('/', '').replace('-', '_') || 'unknown';
  };

  return null; // This component doesn't render anything
}

export default PageTracker;
